// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-width {
  max-width: 650px;
}

.confirmation-tooltip {
  margin: 6px 0 0 10px;
}

.col-center-block {
  float: none;
  display: block;
  margin: 0 auto 1rem;
}

.form-input {
  width: 50% !important;
  min-width: 16rem;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbmZpcm1hdGlvbi1kaWFsb2cuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxnQkFBQTtBQUNGOztBQUVBO0VBQ0Usb0JBQUE7QUFDRjs7QUFFQTtFQUNFLFdBQUE7RUFDQSxjQUFBO0VBQ0EsbUJBQUE7QUFDRjs7QUFFQTtFQUNFLHFCQUFBO0VBQ0EsZ0JBQUE7QUFDRiIsImZpbGUiOiJjb25maXJtYXRpb24tZGlhbG9nLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmRpYWxvZy13aWR0aCB7XG4gIG1heC13aWR0aDogNjUwcHg7XG59XG5cbi5jb25maXJtYXRpb24tdG9vbHRpcCB7XG4gIG1hcmdpbjogNnB4IDAgMCAxMHB4O1xufVxuXG4uY29sLWNlbnRlci1ibG9jayB7XG4gIGZsb2F0OiBub25lO1xuICBkaXNwbGF5OiBibG9jaztcbiAgbWFyZ2luOiAwIGF1dG8gMXJlbTtcbn1cblxuLmZvcm0taW5wdXQge1xuICB3aWR0aDogNTAlICFpbXBvcnRhbnQ7XG4gIG1pbi13aWR0aDogMTZyZW07XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dialogs/confirmation-dialog/confirmation-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;AACF;AACA,ouBAAouB","sourcesContent":[".dialog-width {\n  max-width: 650px;\n}\n\n.confirmation-tooltip {\n  margin: 6px 0 0 10px;\n}\n\n.col-center-block {\n  float: none;\n  display: block;\n  margin: 0 auto 1rem;\n}\n\n.form-input {\n  width: 50% !important;\n  min-width: 16rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
